import { oc } from "@orpc/contract";
import { z } from "zod";

/**
 * Health check response schema
 */
export const HealthCheckResponseSchema = z.object({
  status: z.literal("ok"),
  timestamp: z.string(),
  version: z.string(),
  uptime: z.number(),
  environment: z.string(),
  database: z.object({
    status: z.enum(["healthy", "unhealthy"]),
    latency: z.number().optional(),
  }),
  services: z
    .record(
      z.string(),
      z.object({
        status: z.enum(["healthy", "unhealthy", "degraded"]),
        latency: z.number().optional(),
        error: z.string().optional(),
      }),
    )
    .optional(),
});

/**
 * Health check contract - no input required
 */
export const healthContract = oc.output(HealthCheckResponseSchema).route({
  method: "GET",
});

export type HealthCheckResponse = z.infer<typeof HealthCheckResponseSchema>;
